import { render } from "./TooltipsContent.vue?vue&type=template&id=ff40943e"
import script from "./TooltipsContent.vue?vue&type=script&lang=js"
export * from "./TooltipsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__